import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorage } from '../enums/local-storage.enum';
import { LocalStorageService } from '../services';



export const guestGuard: CanActivateFn = () => {
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);

  if (!localStorageService.getData(LocalStorage.accessToken)) {
    return true;
  }

  router.navigate(['/application/dashboard']);
  return false;
};
